import { Checkbox } from '@lt/components';
import { useTranslation } from '@lt/localization';
import React from 'react';
import styled from 'styled-components';
import { JOINT_STATES } from '../constants';
import type { JointProps } from '../types';
import { isCheckboxChecked } from '../utils';

const JointOrderCheckbox = (props: JointProps): JSX.Element => {
  const { jointState, setJointState, isMobile, isHotel } = props;
  const handleCheckboxClicked = () => {
    if (!isCheckboxChecked(jointState)) setJointState(JOINT_STATES.FIRST_ORDER);
    else setJointState(JOINT_STATES.NOT_JOINT);
  };
  const { t } = useTranslation();
  const checkboxTitle = t(
    isHotel
      ? 'checkout.services.jointOrder.checkboxTitleHotel'
      : 'checkout.services.jointOrder.checkboxTitleTour',
  );
  const checkboxDescription = t(
    'checkout.services.jointOrder.checkboxDescription',
  );
  return (
    <StyledCheckboxWrapper>
      <CheckboxContainer $isMobile={isMobile}>
        <Checkbox
          onChange={handleCheckboxClicked}
          checked={isCheckboxChecked(jointState)}
        />
        <StyledTitle>{checkboxTitle}</StyledTitle>
      </CheckboxContainer>
      <CheckboxDescription $isMobile={isMobile}>
        {checkboxDescription}
      </CheckboxDescription>
    </StyledCheckboxWrapper>
  );
};
const StyledCheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const CheckboxContainer = styled.div<{ $isMobile: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  ${({ $isMobile }) =>
    $isMobile
      ? `
        flex-direction: row-reverse; 
        justify-content: space-between;`
      : `width: 660px;`};
`;

const StyledTitle = styled.span`
  font-size: 14px;
  font-weight: 400;
`;

const CheckboxDescription = styled.div<{ $isMobile: boolean }>`
  color: #919499;
  font-size: 14px;
`;
export default JointOrderCheckbox;
